import React from 'react'
import {
  FacebookShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  InstapaperIcon,
  LinkedinIcon,
  TwitterIcon,
  WhatsappIcon,
} from 'react-share'

const ShareSocials = ({ title }) => {
  const windowGlobal = typeof window !== 'undefined' && window
  const url = String(windowGlobal.location) // to share current page
  const size = '2.5rem'

  return (
    <>
      <h2 className="h4">Partager sur les réseaux sociaux</h2>
      <div className="social-share">
        <FacebookShareButton className="share-button" url={url} quote={title}>
          <FacebookIcon size={size} />
        </FacebookShareButton>
        <InstapaperShareButton className="share-button" url={url} title={title}>
          <InstapaperIcon size={size} />
        </InstapaperShareButton>
        <LinkedinShareButton className="share-button" url={url} title={title}>
          <LinkedinIcon size={size} />
        </LinkedinShareButton>
        <TwitterShareButton className="share-button" url={url} title={title}>
          <TwitterIcon size={size} />
        </TwitterShareButton>
        <WhatsappShareButton className="share-button" url={url} title={title}>
          <WhatsappIcon size={size} />
        </WhatsappShareButton>
      </div>
    </>
  )
}

export default ShareSocials
